import { isObject, isString } from 'radash';
import { ReactNativeMessageType, type ReactNativeMessage } from 'types';

const reactNativeMessageTypes: ReadonlySet<string> = new Set(Object.values(ReactNativeMessageType));

const isReactNativeMessageType = (value: unknown): value is ReactNativeMessageType => isString(value) && reactNativeMessageTypes.has(value);

const isIncomingRnMessage = (value: unknown): value is ReactNativeMessage => {
  if (!isObject(value)) {
    return false;
  }

  if (!isReactNativeMessageType('type' in value ? value.type : undefined)) {
    return false;
  }

  return 'payload' in value && isObject(value.payload);
};

export const parseRnMessageData = (data: unknown): ReactNativeMessage | null => {
  try {
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    return isIncomingRnMessage(parsed) ? parsed : null;
  } catch {
    return null;
  }
};
